import { useEffect } from 'react';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
import { getScriptSrc, loadScript } from './utils/script';

export default function DatawrapperEmbedBlock({ html, condition, callback }) {
  if ('undefined' === typeof window.xtalk) {
    import('../../../../entries/responsive-iframe/index.js');
  }
  const {
    scriptSrc,
    scriptIsText,
  } = getScriptSrc(html);

  useEffect(() => {
    if (condition) {
      callback();
    } else {
      loadScript(scriptSrc, scriptIsText);
    }
  }, []);

  return parse(DOMPurify.sanitize(html, {
    FORBID_TAGS: ['script', 'style'],
    ADD_TAGS: ['iframe'],
    ADD_ATTR: ['frameborder', 'scrolling', 'marginheight', 'target'],
  }));
}

DatawrapperEmbedBlock.propTypes = {
  html: PropTypes.string.isRequired,
  condition: PropTypes.bool,
  callback: PropTypes.func,
};

DatawrapperEmbedBlock.defaultProps = {
  condition: false,
  callback: () => {},
};
